import { FC } from 'react';
import { QuerySwitch } from 'components/QuerySwitch';
import {
  SeniorityRankingDataContext,
  SeniorityRankingDataProvider,
} from 'pages/Settings/pages/Organization/SeniorityRankingPage/SeniorityRankingPage.data.context';
import { SeniorityRankingFormProvider } from 'pages/Settings/pages/Organization/SeniorityRankingPage/SeniorityRankingPage.form.context';
import isUserSecondarySelector from 'store/selectors/userSelectors/isUserSecondarySelector';
import { useSelector } from 'react-redux';
import { SeniorityRankingTabReadView } from 'pages/Settings/pages/Organization/SeniorityRankingPage/SeniorityRankingPage.read';
import { SeniorityRankingTabEditView } from 'pages/Settings/pages/Organization/SeniorityRankingPage/SeniorityRankingPage.edit';

export const SeniorityRankingFormTab: FC = () => {
  const isUserSecondary = useSelector(isUserSecondarySelector);
  if (isUserSecondary) {
    return <SeniorityRankingTabReadView />;
  }

  return (
    <SeniorityRankingFormProvider>
      <SeniorityRankingTabEditView />
    </SeniorityRankingFormProvider>
  );
};

export const SeniorityRankingPage: FC = () => {
  return (
    <SeniorityRankingDataProvider>
      <QuerySwitch context={SeniorityRankingDataContext} component={SeniorityRankingFormTab} />
    </SeniorityRankingDataProvider>
  );
};
